import {request} from '@/utils/http';

let uploadfile = '/common/file/common/upload';
let navbar = '/fronted/navigation/all'
let sms = '/common/sms/token'
let sendsms = '/common/sms/send'
let verifysms = '/common/sms/verify/code'
let companyType = '/common/company/types'
let settingPhone = '/common/setting/phone'
let analysisSave = '/fronted/analysis/save'
let settingInfo = '/fronted/setting/info'
let secret = '/fronted/mystical/isOpened'
let download='/fronted/app/current'

export function GET_APPCURRENT(params){
  return request(download,'get',params)
}
export function POST_UPLOADFILE(params){
    let headers={'Content-Type': 'multipart/form-data'}
  return request(uploadfile,'post',params,headers,false)
}
export function GET_NAVBAR(params){
    return request(navbar,'get',params)
}
export function GET_SMS(params){
  return request(sms,'get',params)
}
export function GET_SENDSMS(params){
  let headers={'Content-Type': 'application/x-www-form-urlencoded'}
  return request(sendsms,'get',params,headers,false)
}
export function GET_VERIFYSMS(params){
  return request(verifysms,'get',params)
}
export function GET_COMPANYTYPE(params){
  return request(companyType,'get',params)
}
export function GET_SETTINGPHONE(params){
  return request(settingPhone,'get',params)
}
export function POST_ANALYSISSAVE(params){
  return request(analysisSave,'post',params,{},true,'',true)
}
export function GET_SETTINGINFO(params){
  return request(settingInfo,'get',params)
}
export function POST_SECRETACTIVITY(params){
  return request(secret,'post',params,{},'','',true)
}



// WEBPACK FOOTER //
// ./src/api/common.api.js